const rejectionPayoutCategoryList = ['9', '15', '10', '11', 'all']

const DEMO_BRAND_PARTNER_ID = 294

const DYNAMIC_REJECTION_PAYOUT_UPTO_100 = 'upto ₹100'
const REJECTION_PAYOUT = '₹25'

const MAGNET_CARD_PARTNER_ID = 193
const CREDIT_BEE = '185'
const MAGNET = '193'

const REASON_LIST = ['LEAD_EXISTS', 'ETB', 'PPNL']

const PROFIT_ON_ACTIVATION_BRAND_IDS = [
  '173',
  '242',
  '243',
  '244',
  '257',
  '259',
  '260',
  '264',
  '272',
  '273',
  '274',
  '222',
  '245',
  '246',
  '235',
  '277',
  '288',
  '282',
]

const REFRESH_PAGE_WEBVIEW_EVENT = 'REFRESH_PAGE'
const NAVIGATE_TO_MAGNET_CARD_SCREEN_WEBVIEW_EVENT =
  'NAVIGATE_TO_MAGNET_CARD_SCREEN'

const RECOMMENDATION_WEB_PAGE_LOADED = 'RECOMMENDATION_WEB_PAGE_LOADED'
const RECOMMENDATION_API_SUCCESS = 'RECOMMENDATION_API_SUCCESS'
const RECOMMENDATION_API_FAILED = 'RECOMMENDATION_API_FAILED'

const PayoutBreakDownLoyalty = {
  BEGINNER: [{ type: 'coins', prefix: '', value: '', suffix: '' }],
  OTHER_TIER: [
    { type: 'loyalty', prefix: '', value: '', suffix: '' },
    { type: 'coins', prefix: '', value: '', suffix: '' },
  ],
}

const PAYOUT_TYPE = {
  LOYALTY: 'loyalty',
  COINS: 'coins',
}

const extraLoyaltyPayoutEligibleCategory = [
  '9',
  '10',
  '11',
  '12',
  '15',
  '18',
  '25',
  '27',
]

const minBasePayoutToGetCoins = 250
const maxCoinsLimitWeekly = 10000
const EN = 'English'
const HI = 'Hindi'

const MAGNET_CARD_PROMOTION_URL =
  'https://onecode-asset.s3.ap-south-1.amazonaws.com/magnetPromotion.webp'

const defaultThumbnail =
  'https://onecode-asset.s3.ap-south-1.amazonaws.com/zet/Thumbnails/ApplicationForm.png'
const termsAndConditionsLink =
  'https://onecode-asset.s3.ap-south-1.amazonaws.com/Terms+of+Use+and+User+Consent.docx.pdf'
const privacyPolicyLink =
  'https://onecode-asset.s3.ap-south-1.amazonaws.com/Privacy+Policy+Zet+Customer.docx.pdf'
const experianConsent =
  'https://onecode-asset.s3.ap-south-1.amazonaws.com/Experian_Consumer+Consent.pdf'
const termsAndConditionsForExperianLink =
  'https://onecode-asset.s3.ap-south-1.amazonaws.com/Terms+of+Use+and+User+Consent+of+Customer+Experian.pdf'
const privacyPolicyForExperianLink =
  'https://onecode-asset.s3.ap-south-1.amazonaws.com/Privacy+Policy+Zet+Customer+Experian.pdf'

const REDIRECTION_LINK = 'redirectionLink'

const CBMLogoUrl =
  'https://onecode-asset.s3.ap-south-1.amazonaws.com/ZET_Partner/Reactivation+Campaign+/CIBIL+builder.png'

const CBMBannerDetailsUrl =
  'https://onecode-asset.s3.ap-south-1.amazonaws.com/zet/CiBilBuilderLoanAssets/CBMApproval.png'

const CBMIllustration =
  'https://onecode-asset.s3.ap-south-1.amazonaws.com/zet/CiBilBuilderLoanAssets/Credit+Builder+Membership+Illustration+Banner+Image.png'

const iplTopStrapImg =
  'https://onecode-asset.s3.ap-south-1.amazonaws.com/ZET_Partner/SPL/Top+Strap+(1).png'

const sbmCrossSellImages = {
  bgImg:
    'https://onecode-asset.s3.ap-south-1.amazonaws.com/ZET_Partner/Magnet/New+ZET+Card+Pitch+Banner.png',
  hookLine:
    'https://onecode-asset.s3.ap-south-1.amazonaws.com/ZET_Partner/Magnet/Hook+line.png',
  approvalImg:
    'https://onecode-asset.s3.ap-south-1.amazonaws.com/ZET_Partner/Magnet/Container.png',
  sbmIllustration:
    'https://onecode-asset.s3.ap-south-1.amazonaws.com/ZET_Partner/Magnet/Magnet+Card+Illustration.png',
}

const blmTopStrapImg =
  'https://onecode-asset.s3.ap-south-1.amazonaws.com/ZET_Partner/Bharat+Loans+Mahotsav/Top+Strap+(1).png'

const magnetIds = Object.freeze({
  brandId: 193,
  variantId: 271,
})

export {
  blmTopStrapImg,
  CBMBannerDetailsUrl,
  CBMIllustration,
  CBMLogoUrl,
  CREDIT_BEE,
  defaultThumbnail,
  DEMO_BRAND_PARTNER_ID,
  DYNAMIC_REJECTION_PAYOUT_UPTO_100,
  EN,
  experianConsent,
  extraLoyaltyPayoutEligibleCategory,
  HI,
  iplTopStrapImg,
  MAGNET,
  MAGNET_CARD_PARTNER_ID,
  MAGNET_CARD_PROMOTION_URL,
  magnetIds,
  maxCoinsLimitWeekly,
  minBasePayoutToGetCoins,
  NAVIGATE_TO_MAGNET_CARD_SCREEN_WEBVIEW_EVENT,
  PAYOUT_TYPE,
  PayoutBreakDownLoyalty,
  privacyPolicyForExperianLink,
  privacyPolicyLink,
  PROFIT_ON_ACTIVATION_BRAND_IDS,
  REASON_LIST,
  RECOMMENDATION_API_FAILED,
  RECOMMENDATION_API_SUCCESS,
  RECOMMENDATION_WEB_PAGE_LOADED,
  REDIRECTION_LINK,
  REFRESH_PAGE_WEBVIEW_EVENT,
  REJECTION_PAYOUT,
  rejectionPayoutCategoryList,
  sbmCrossSellImages,
  termsAndConditionsForExperianLink,
  termsAndConditionsLink,
}
